// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__lP3AH","circular":"style_circular__3rri2","rotate":"style_rotate__3a1uj","path":"style_path__2WWVv","dash":"style_dash__BujPd","color":"style_color__10VeQ"};